import axios from 'axios';

const API = '/api';

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const authAPI = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },
  me: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
  logout: async () => {
    await api.post('/auth/logout');
  },
};

export const blogAPI = {
  getPosts: async (page = 1, limit = 10, category = null) => {
    const params = { page, limit };
    if (category) params.category = category;
    const response = await api.get('/blog/posts', { params });
    return response.data;
  },
  getPostBySlug: async (slug) => {
    const response = await api.get(`/blog/posts/${slug}`);
    return response.data;
  },
  createPost: async (postData) => {
    const response = await api.post('/blog/posts', postData);
    return response.data;
  },
  updatePost: async (postId, postData) => {
    const response = await api.put(`/blog/posts/${postId}`, postData);
    return response.data;
  },
  deletePost: async (postId) => {
    const response = await api.delete(`/blog/posts/${postId}`);
    return response.data;
  },
};

export const contactAPI = {
  submitMessage: async (messageData) => {
    const response = await api.post('/contact/submit', messageData);
    return response.data;
  },
  getMessages: async () => {
    const response = await api.get('/contact/messages');
    return response.data;
  },
  markRead: async (messageId) => {
    const response = await api.patch(`/contact/messages/${messageId}/read`);
    return response.data;
  },
};

export const testimonialsAPI = {
  getTestimonials: async () => {
    const response = await api.get('/testimonials');
    return response.data;
  },
  submitTestimonial: async (testimonialData) => {
    const response = await api.post('/testimonials/submit', testimonialData);
    return response.data;
  },
  approveTestimonial: async (testimonialId) => {
    const response = await api.patch(`/testimonials/${testimonialId}/approve`);
    return response.data;
  },
  getPendingTestimonials: async () => {
    const response = await api.get('/testimonials/pending');
    return response.data;
  },
};

export const conferencesAPI = {
  getAll: async (type = null) => {
    const params = type ? { type } : {};
    const response = await api.get('/conferences', { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/conferences/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/conferences', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/conferences/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/conferences/${id}`);
    return response.data;
  },
};

export const communityAPI = {
  getAll: async () => {
    const response = await api.get('/community');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/community/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/community', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/community/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/community/${id}`);
    return response.data;
  },
};

export const faqsAPI = {
  getAll: async (publishedOnly = true) => {
    const response = await api.get('/faqs', { params: { published_only: publishedOnly } });
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/faqs', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/faqs/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/faqs/${id}`);
    return response.data;
  },
};

export const mediaAPI = {
  getAll: async () => {
    const response = await api.get('/media');
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/media', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/media/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/media/${id}`);
    return response.data;
  },
};

export const galleryAPI = {
  getAll: async (category = null) => {
    const params = category ? { category } : {};
    const response = await api.get('/gallery', { params });
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/gallery', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/gallery/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/gallery/${id}`);
    return response.data;
  },
};

export const newsletterAPI = {
  subscribe: async (data) => {
    const response = await api.post('/newsletter/subscribe', data);
    return response.data;
  },
  getSubscribers: async () => {
    const response = await api.get('/newsletter/subscribers');
    return response.data;
  },
  removeSubscriber: async (id) => {
    const response = await api.delete(`/newsletter/subscribers/${id}`);
    return response.data;
  },
};

export const awardsAPI = {
  getAll: async () => {
    const response = await api.get('/awards');
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/awards', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/awards/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/awards/${id}`);
    return response.data;
  },
};

export default { auth: authAPI, blog: blogAPI, contact: contactAPI, testimonials: testimonialsAPI, conferences: conferencesAPI, community: communityAPI };
